import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import Form, { convertObjToJbuilder, convertJBuilderToObj } from 'global/components/form';
import { get, flatten, set, unset, size } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { Text } from 'global/components/text';
import { Button } from '../../../global/components/Button';
import { Row } from '../../../global/components/row';
import { Icon, Paper } from '@material-ui/core';
import SnackAlerts from 'global/components/snack-alerts';
import { cleanCopy, guid, letterFromAlphabet, makeArray, stringObj } from '../../../global/utils';
import { sendData } from 'redux/actions/sendData';
import { awaitAll } from '../../../global/utils/awaitAll';
import { sortItemsAlphabetically } from 'global/utils';
import { isObject } from '../../../global/lib/lodash';

const defaults = {
  name: '',
  description: '',
  isDirty: false,
};

const defaultScore = {
  0: '',
  100: '',
};

const gpadefaultScore = {
  0: '',
  25: '',
  50: '',
  75: '',
  100: '',
};

const opts = [{ id: '0' }, { id: '100' }];

const gpaopts = [{ id: '0' }, { id: '25' }, { id: '50' }, { id: '75' }, { id: '100' }];

const allopts = makeArray(101).map((a, i) => ({ id: i.toString() }));

export const CreateChecklist = (props) => {
  const { doc } = props;
  const classes = useStyles();

  const [state, setState] = useState({
    isEdit: !!props.checklist, // false,
    checkpoints: !!props.checklist ? get(props, 'checklist.checkpoints', []) : [guid()],
    update: 0,
  });

  const [formState, setFormState] = useState({});
  let [dFormState, _setDFormState] = useState({});
  const [alerts, setAlerts] = useState();

  const dref = useRef();
  const drefprev = useRef();
  const cpref = useRef();

  const supersets = useRetrieveData(
    { url: '/systems' },
    {
      build: ['systems'],
      transformData: (d) => {
        return d.map((item) => ({ ...item, value: item.id, title: item.name }));
      },
    }
  );

  const classifications = useRetrieveData(
    { url: '/classifications' },
    {
      build: ['classifications'],
      transformData: (d) => {
        return d.map((item) => ({ ...item, value: item.id, title: item.name }));
      },
    }
  );

  const setDFormState = (fs) => {
    const cur = dFormState.toggle2;
    dFormState = fs;
    _setDFormState({ ...dFormState });

    const currentcref = get(cpref, 'current', {});

    if (fs.toggle2 != cur && !!cur) {
      dref.current.updateState('toggle2', fs.toggle2, true, false);
      dref.current.updateState('options', convertObjToJbuilder(fs.toggle2 === 1 ? cleanCopy(defaultScore) : cleanCopy(gpadefaultScore)), true, false);

      Object.keys(currentcref).map((k) => {
        const { comp } = currentcref[k];
        comp && comp.updateState && comp.updateState('options', convertObjToJbuilder(fs.toggle2 === 1 ? cleanCopy(defaultScore) : cleanCopy(gpadefaultScore)), true, false);
      });
    }

    const copy = cleanCopy(dFormState.options);
    Object.keys(currentcref).map((k) => {
      const { comp } = currentcref[k];
      const crefoptions = get(comp, 'formState.options', []);

      copy.map((co, i) => {
        const crefind = crefoptions.findIndex((o) => o.property == co.property);
        const crefval = get(crefoptions, `${crefind}.value`);
        const prevValue = get(
          get(drefprev, 'current.options', []).find((o) => o.property == co.property),
          'value'
        );

        if (crefind == -1) {
          set(crefoptions, i, co);
        } else if (!crefval || crefval == prevValue) {
          set(crefoptions, `${crefind}.value`, co.value);
        }
      });

      comp && comp.updateState && comp.updateState('options', cleanCopy(crefoptions), true, false);
    });

    set(drefprev, 'current', cleanCopy(fs));
  };

  const setCpFormState = (cp, fs) => {
    const cpid = isObject(cp) ? `_${cp.id}` : cp;
    const cps = get(cpref, 'current', {});
    set(cps, cpid, fs);
    set(cpref, 'current', cps);
    setState((s) => ({ ...s, update: s.update + 1 }));
  };

  const submit = async () => {
    try {
      const { isEdit } = state;
      const cl = { ...formState };

      const isComplex = get(cl, 'toggle', 1) == 2;
      const rows = get(cl, 'checkdescriptions', '')
        .split('\n')
        .filter((f) => !!f);

      unset(cl, 'system');
      unset(cl, 'toggle');
      unset(cl, 'checkdescriptions');

      let clid = get(props, 'checklist.id');
      const edition_id = get(doc, 'id');
      const edition_document_id = get(
        get(doc, 'editionDocuments', []).find((ed) => ed.documentableId == clid),
        'id'
      );

      if (clid) {
        set(cl, 'edition_id', edition_id);
        set(cl, 'edition_document_id', edition_document_id);
      }

      if (props.update_non_unique) {
        set(cl, 'update_non_unique', 1);
      }

      const createdchecklist = await sendData(
        {
          url: `/checklists${clid ? `/${clid}` : ''}`,
          method: isEdit ? 'patch' : 'post',
          data: {
            data: {
              id: clid,
              type: 'checklists',
              attributes: stringObj(cl),
            },
          },
        },
        {
          normalize: { build: ['checklists'] },
        }
      );

      clid = get(createdchecklist, '0.id', '').toString();

      const cps = [];
      const cpopts = [];

      if (isComplex) {
        state.checkpoints.map((cp) => {
          const isNew = !isObject(cp);
          const cpid = isNew ? cp : `_${cp.id}`;
          const vals = get(cpref, `current.${cpid}`, {});

          const checkpoint = convertJBuilderToObj(vals.checkpoint);
          const options = convertJBuilderToObj(vals.options);

          cps.push({
            data: {
              data: {
                id: isNew ? undefined : cp.id.toString(),
                type: 'checkpoints',
                attributes: stringObj({
                  name: get(checkpoint, 'name', ''),
                  description: get(checkpoint, 'description', ''),
                  notes: get(checkpoint, 'notes', ''),
                  ...(isNew ? {} : { edition_id, edition_document_id }),
                }),
                relationships: {
                  checklists: {
                    data: [{ type: 'checklists', id: clid }],
                  },
                },
              },
            },
            onSuccess: async (created) => {
              //delete removed ones
              await Promise.all(
                get(cp, 'checkpointOptions', []).map(async (f) => {
                  const isDel = !options[f.value];
                  if (isDel) {
                    await sendData({
                      url: `/checkpoint-options/${f.id}`,
                      method: 'delete',
                      data: {
                        data: {
                          type: 'checkpoint-options',
                          id: f.id,
                        },
                      },
                    });
                  }
                })
              );

              await Promise.all(
                Object.keys(options).map(async (k) => {
                  const cpo = !isNew ? get(cp, 'checkpointOptions', []).find((o) => o.value == k) : undefined;

                  const meth = {
                    url: !!cpo ? `/checkpoint-options/${cpo.id}` : `/checkpoint-options`,
                    method: !!cpo ? 'patch' : 'post',
                  };

                  await sendData({
                    ...meth,
                    data: {
                      data: {
                        id: !!cpo ? cpo.id : undefined,
                        type: 'checkpoint-options',
                        attributes: stringObj({
                          checkpoint_id: get(created, '0.id'),
                          name: options[k], //TODO backend says name can't be blank
                          value: k, //TODO backend says something about default value
                        }),
                      },
                    },
                  });
                })
              );
            },
          });
        });
      } else {
        rows.map((r, i) => {
          cps.push({
            data: {
              data: {
                type: 'checkpoints',
                attributes: {
                  name: letterFromAlphabet(i),
                  description: r,
                },
                relationships: {
                  checklists: {
                    data: [{ type: 'checklists', id: clid }],
                  },
                },
              },
            },
            onSuccess: async (created) => {
              const simpleopts = [
                { name: '', value: 0 },
                { name: '', value: 100 },
              ];

              await Promise.all(
                simpleopts.map(async (opt) => {
                  await sendData({
                    url: `/checkpoint-options`,
                    method: 'post',
                    data: {
                      data: {
                        type: 'checkpoint-options',
                        attributes: stringObj({
                          checkpoint_id: get(created, '0.id'),
                          name: opt.name,
                          value: opt.value,
                        }),
                      },
                    },
                  });
                })
              );
            },
          });
        });
      }

      if (state.isEdit) {
        await Promise.all(
          get(props, 'checklist.checkpoints', []).map(async (cp) => {
            const isDel = isObject(cp) && !state.checkpoints.find((c) => c.id == cp.id) ? true : false;

            if (isDel) {
              await sendData({
                url: `/checkpoints/${cp.id}`,
                method: 'delete',
                data: {
                  data: {
                    type: 'checkpoints',
                    id: cp.id,
                  },
                },
              });
            }
          })
        );
      }

      await awaitAll(
        cps.map((cp) => () => async () => {
          const hasId = get(cp, 'data.data.id');
          let bUpdateExistingCp = false;

          if (hasId) {
            const aCurrentCPItems = get(cpref, `current._${hasId}.checkpoint`);
            const aCurrentCPOptions = get(cpref, `current._${hasId}.options`);
            const isCpModified = aCurrentCPItems[1].isDirty || aCurrentCPItems[2].isDirty ? true : false;
            const isCpOptionsModified = aCurrentCPOptions.length == 2 && (aCurrentCPOptions[0].isDirty || aCurrentCPOptions[1].isDirty) ? true : false;
            bUpdateExistingCp = isCpModified || isCpOptionsModified;
          }

          if (!hasId || bUpdateExistingCp) {
            const result = await sendData(
              {
                url: `/checkpoints${hasId ? `/${hasId}` : ''}`,
                method: !hasId ? 'post' : 'patch',
                data: cp.data,
              },
              { normalize: { build: ['checkpoints'] } }
            );

            if (cp.onSuccess) {
              await cp.onSuccess(result);
            }
          }
        })
      );

      const classid = get(cl, 'classification_id');
      const amt = size(get(doc, 'documents', []).filter((f) => f.classificationId == classid));

      if (!state.isEdit) {
        await sendData({
          url: `/edition-documents`,
          method: 'post',
          data: {
            data: {
              type: 'edition-documents',
              attributes: stringObj({
                edition_id,
                documentable_id: clid,
                documentable_type: 'checklist',
                classification_id: classid,
                order: amt,
                primary_document: !amt ? 1 : 0,
              }),
            },
          },
        });
      }

      props.onClose && props.onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  const addCheckpoint = () => {
    const id = guid();
    setState((s) => ({ ...s, checkpoints: [...s.checkpoints, id] }));
  };

  const removeCheckpoint = (cp) => {
    const checkpoints = state.checkpoints.filter((c) => c !== cp);
    setState((s) => ({ ...s, checkpoints: !size(checkpoints) ? [guid()] : checkpoints }));
    unset(cpref, `current.${cp}`);
  };

  const getValidCheckpointOpts = (obj = {}) => {
    const ret = {
      id: obj.id,
      name: obj.name,
      description: obj.description,
      notes: obj.notes,
    };

    Object.keys(ret).map((k) => {
      const val = get(ret, k);

      if (!val) {
        unset(ret, k);
      }
    });

    return ret;
  };

  const cposToObj = (cpos = []) => {
    const obj = {};
    cpos.map((cpo) => {
      obj[cpo.value] = cpo.name;
    });
    return convertObjToJbuilder(obj);
  };

  const data = props.checklist || {};

  const allCheckpointsValid = () => {
    const cps = flatten(
      state.checkpoints.map((_id) => {
        const id = isObject(_id) ? `_${_id.id}` : _id;
        const obj = get(cpref, `current.${id}.comp.formState`, get(cpref, `current.${id}`), {});

        return [...(get(obj, 'checkpoint', []) || []), ...(get(obj, 'options', []) || [])];
      })
    ).filter((cp) => get(cp, 'property') !== 'id');

    const valid = cps.filter((cp) => cp.valid);

    return size(valid) >= size(cps);
  };

  const createDisabled = !get(formState, 'classification_id') || (get(formState, 'toggle', 1) == 1 ? !get(formState, 'checkdescriptions') : !allCheckpointsValid());

  return (
    <div>
      <Form
        showAllScreens
        formLoading={state.formLoading}
        onFormState={setFormState}
        formStyle={classes.formStyle}
        screens={[
          {
            inputs: [
              {
                id: 'name',
                type: 'TextField',
                defaultValue: () => get(data, 'name', ''),
                props: {
                  label: 'Title',
                },
              },
              {
                id: 'description',
                type: 'TextField',
                defaultValue: () => get(data, 'description', ''),
                props: {
                  label: 'Description',
                  rows: 6,
                  multiline: true,
                },
              },
              {
                id: 'system',
                type: 'Select',
                data: () => supersets.data,
                defaultValue: () => parseInt(get(data, 'classification.system.id', get(data, 'system.id', 0))),
                props: {
                  label: 'System',
                  placeholder: 'Choose a System',
                },
              },
              {
                id: 'classification_id',
                type: 'Select',
                data: () => sortItemsAlphabetically(classifications.data.filter((f) => get(f, 'system.id') == get(formState, 'system'))),
                defaultValue: () => get(data, 'classificationId', 0).toString(),
                props: {
                  label: 'Classification',
                  placeholder: 'Choose Classification',
                  disabled: !get(formState, 'system'),
                  helperText: 'Why do we require a classification? This is the standardized data-point that organizes content together and allows the site to collate data more effectively.',
                },
              },
              {
                id: 'toggle',
                type: 'ToggleButton',
                options: [
                  { title: 'SIMPLE', value: 1 },
                  { title: 'COMPLEX', value: 2 },
                ],
                center: true,
                defaultValue: () => get(formState, 'toggle', state.isEdit ? 2 : 1),
                props: {
                  label: 'Method',
                  exclusive: true,
                  disabled: state.isEdit,
                },
              },
              ...(get(formState, 'toggle', 1) == 1
                ? [
                    {
                      id: 'checkdescriptions',
                      type: 'TextField',
                      defaultValue: () => get(data, 'checkdescriptions', ''),
                      props: {
                        label: '',
                        rows: 8,
                        multiline: true,
                        placeholder: 'Add checkpoint descriptions separated by line',
                      },
                    },
                  ]
                : [
                    !state.isEdit && {
                      id: 'defaults',
                      component: () => (
                        <div style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: 8 }}>
                          <Text>Default Checkpoint Options</Text>
                          <Form
                            showAllScreens
                            onFormState={setDFormState}
                            ref={dref}
                            screens={[
                              {
                                inputs: [
                                  {
                                    id: 'toggle2',
                                    type: 'ToggleButton',
                                    defaultValue: () => get(dFormState, 'toggle2', 1),
                                    options: [
                                      { title: '0-100% (Pass/Fail)', value: 1 },
                                      { title: '0-4 (GPA)', value: 2 },
                                    ],
                                    props: {
                                      label: 'Presets',
                                      exclusive: true,
                                    },
                                  },
                                  {
                                    id: 'options',
                                    type: 'JsonBuilder',
                                    defaultValue: () => convertObjToJbuilder(defaultScore),
                                    addBtn: {
                                      title: 'ADD OPTION',
                                    },
                                    options: allopts.map((o) => ({
                                      ...o,
                                      label: `${o.id}%`,
                                      props: {
                                        placeholder: 'None',
                                        blankAllowed: true,
                                      },
                                    })),
                                    props: {
                                      label: 'Checkpoint Options',
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      ),
                    },
                    ...state.checkpoints.map((cp, i) => {
                      const cpid = isObject(cp) ? `_${cp.id}` : cp;
                      return {
                        id: `checkpoints_${cpid}`,
                        add: i === state.checkpoints.length - 1,
                        addBtn: {
                          title: 'ADD CHECKPOINT',
                        },
                        deleteBtn: {
                          title: 'REMOVE CHECKPOINT',
                        },
                        inputStyle: classes.checkContainer,
                        remove: size(state.checkpoints) > 1,
                        onAdd: addCheckpoint,
                        onRemove: () => {
                          removeCheckpoint(cp);
                        },
                        component: (
                          <div>
                            <Form
                              showAllScreens
                              onFormState={(fs) => setCpFormState(cp, fs)}
                              ref={(r) => set(cpref, `current.${cpid}.comp`, r)}
                              screens={[
                                {
                                  inputs: [
                                    {
                                      id: 'checkpoint',
                                      type: 'JsonBuilder',
                                      defaultValue: () => convertObjToJbuilder(isObject(cp) ? getValidCheckpointOpts(cp) : defaults),
                                      addBtn: {
                                        title: 'ADD OPTION',
                                      },
                                      options: [
                                        {
                                          id: 'id',
                                          canDelete: false,
                                          show: false,
                                        },
                                        {
                                          id: 'name',
                                          label: 'Title',
                                          canDelete: false,
                                          props: {
                                            placeholder: 'None',
                                          },
                                        },
                                        {
                                          id: 'description',
                                          label: 'Description',
                                          props: {
                                            placeholder: 'None',
                                            blankAllowed: true,
                                          },
                                        },
                                        {
                                          id: 'notes',
                                          label: 'Notes',
                                          props: {
                                            placeholder: 'None',
                                          },
                                        },
                                      ],
                                      props: {
                                        label: 'Checkpoint',
                                      },
                                    },
                                    {
                                      id: 'options',
                                      type: 'JsonBuilder',
                                      style: { paddingLeft: '10%', width: '90%' },
                                      addBtn: {
                                        title: 'ADD OPTION',
                                      },
                                      defaultValue: () => (isObject(cp) ? cposToObj(get(cp, 'checkpointOptions', [])) : cleanCopy(dFormState.options || [])),
                                      options: allopts.map((o) => ({
                                        ...o,
                                        label: `${o.id}%`,
                                        props: {
                                          placeholder: 'None',
                                          blankAllowed: true,
                                        },
                                      })),
                                      props: {
                                        label: 'Checkpoint Options',
                                      },
                                    },
                                  ],
                                },
                              ]}
                            />
                          </div>
                        ),
                      };
                    }),
                  ].filter((f) => !!f)),
            ],
          },
        ]}
      />
      <Row fullWidth center>
        <Button disabled={createDisabled} onClick={submit} startIcon={<Icon>save</Icon>}>
          {state.isEdit ? 'UPDATE' : 'CREATE'}
        </Button>
      </Row>
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  formStyle: {
    overflow: 'visible',
  },
  checkContainer: {
    boxShadow: '0 0 8px rgba(0,0,0,0.4)',
    marginBottom: 16,
    boxSizing: 'border-box',
    padding: 8,
  },
}));
